export default __webpack_public_path__ + "37e78673be7a4f03007bfc138a77fe5a.png";